var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingBuyerInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Pricing_Buyer_Info"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pricing_Buyer_Info",
    "data-name": "Pricing, Buyer Info",
    clipPath: "url(#clip-Pricing_Buyer_Info)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11812",
    "data-name": "Group 11812",
    transform: "translate(0.673 0.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11813",
    "data-name": "Group 11813",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22297",
    "data-name": "Path 22297",
    d: "M15.885,16.646h-.139a.971.971,0,0,1-.723-.575c-.123-.286-.266-.563-.4-.844q-.656-1.364-1.311-2.729c-.093-.193-.061-.321.089-.419.079-.052.222-.052.231-.151s-.072-.177-.113-.265c-.01-.021-.021-.041-.029-.063-.038-.1-.088-.133-.209-.1a3.038,3.038,0,0,1-.9.145c-.132,0-.175.031-.174.172.007,1.04,0,2.081.006,3.121a.407.407,0,0,1-.136.321c-.252.238-.5.479-.752.719a.279.279,0,0,1-.451,0c-.172-.163-.342-.328-.508-.5a.111.111,0,0,0-.187,0c-.168.167-.342.328-.513.492a.284.284,0,0,1-.464,0c-.167-.16-.335-.318-.5-.484-.075-.077-.127-.071-.2,0-.163.163-.334.32-.5.48a.289.289,0,0,1-.477,0c-.162-.156-.328-.31-.483-.473-.08-.084-.136-.076-.212,0-.158.16-.325.312-.487.469-.18.174-.3.174-.489,0-.154-.148-.314-.291-.458-.449-.1-.107-.161-.088-.251,0-.153.157-.316.3-.475.457a.285.285,0,0,1-.464,0c-.159-.151-.321-.3-.471-.46-.091-.1-.154-.107-.25-.006-.155.163-.324.313-.487.469a.28.28,0,0,1-.451,0c-.172-.163-.342-.328-.508-.5-.067-.068-.117-.072-.186,0-.168.167-.341.329-.513.492a.284.284,0,0,1-.464,0c-.294-.284-.585-.57-.877-.855V.138A.51.51,0,0,1,.408,0Q6.12.005,11.832,0c.3,0,.376.075.376.377,0,1.1,0,2.207,0,3.311,0,.161.045.2.2.2a2.828,2.828,0,0,1,.7.1A3.887,3.887,0,0,1,15.456,9.9a3.8,3.8,0,0,1-1.39,1.274c-.1.055-.139.108-.064.209a.563.563,0,0,1,.047.092c.108.221.108.221.34.116a.272.272,0,0,1,.391.132c.083.158.158.321.235.482q.773,1.605,1.545,3.211a.822.822,0,0,1-.2,1.006,1.3,1.3,0,0,1-.478.222M9.8,10.821A3.851,3.851,0,0,1,8.333,8.04a4.111,4.111,0,0,1,1.23-3.108,3.507,3.507,0,0,1,1.581-.918,1.149,1.149,0,0,0,.352-.062c.113-.017.161-.057.16-.187-.007-.977,0-1.954,0-2.93,0-.282,0-.282-.285-.282H.774C.555.552.555.552.555.78c0,4.5.008,9-.012,13.507a1.11,1.11,0,0,0,.468,1.041.05.05,0,0,1,.012.012c.061.084.116.064.181,0q.252-.251.512-.493a.279.279,0,0,1,.453,0c.165.153.334.3.486.469.1.107.159.086.247-.006.148-.154.306-.3.461-.446.186-.176.3-.176.492,0,.16.15.322.3.474.457.081.085.136.094.221,0,.147-.155.306-.3.46-.446.205-.2.314-.2.517-.008.164.154.329.309.486.47.069.07.115.071.183,0,.167-.168.339-.331.512-.493a.277.277,0,0,1,.452,0c.174.16.348.322.513.492.076.078.124.072.2,0,.167-.169.338-.333.511-.494a.276.276,0,0,1,.44,0c.174.16.349.321.512.492.083.087.134.073.209,0,.163-.164.33-.323.5-.481a.277.277,0,0,1,.452,0c.174.161.346.324.513.492.066.067.113.079.183.007.128-.133.262-.261.4-.386a.224.224,0,0,0,.067-.186q0-1.509,0-3.017a.177.177,0,0,0-.031-.122.141.141,0,0,0-.092-.041,8.81,8.81,0,0,1-.953-.295,3.855,3.855,0,0,1-.782-.477m2.4.277A3.327,3.327,0,1,0,8.886,7.722,3.315,3.315,0,0,0,12.194,11.1m3.9,4.7a.692.692,0,0,0-.09-.249q-.47-.981-.944-1.96c-.058-.119-.091-.295-.185-.339-.111-.052-.238.1-.367.143-.11.036-.12.085-.068.189.216.433.422.871.632,1.306.163.337.327.673.488,1.011a.278.278,0,0,0,.533-.1M14.337,12.24c-.118.059-.258.126-.395.2-.041.022-.011.061,0,.092.133.42.175.438.564.242.021-.01.04-.022.062-.031.057-.023.059-.059.034-.109-.057-.113-.11-.228-.164-.342-.016-.033-.033-.061-.1-.05",
    transform: "translate(0 0)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22298",
    "data-name": "Path 22298",
    d: "M28.778,10.823A2.774,2.774,0,1,1,26,13.569a2.774,2.774,0,0,1,2.775-2.746m0,.555A2.219,2.219,0,1,0,31,13.607a2.216,2.216,0,0,0-2.22-2.229",
    transform: "translate(-24.06 -9.436)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22299",
    "data-name": "Path 22299",
    d: "M16.031,71.178q-1.36,0-2.72,0a.291.291,0,0,1-.295-.168.255.255,0,0,1,.031-.277.28.28,0,0,1,.241-.11q2.755,0,5.51,0a.268.268,0,0,1,.293.271.272.272,0,0,1-.305.278q-1.377,0-2.755,0Z",
    transform: "translate(-11.325 -60.578)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22300",
    "data-name": "Path 22300",
    d: "M16.064,82.654H18.7c.052,0,.1,0,.156,0a.274.274,0,0,1,0,.547c-.15.008-.3,0-.45,0H13.531c-.075,0-.15,0-.225,0a.277.277,0,1,1,0-.552c.629,0,1.259,0,1.888,0h.866Z",
    transform: "translate(-11.341 -71.066)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22301",
    "data-name": "Path 22301",
    d: "M16.077,59.043H13.389A.406.406,0,0,1,13.155,59a.268.268,0,0,1-.14-.292.259.259,0,0,1,.24-.216.957.957,0,0,1,.121,0h5.358c.029,0,.058,0,.087,0a.275.275,0,1,1,0,.549c-.537,0-1.075,0-1.613,0H16.077Z",
    transform: "translate(-11.343 -49.999)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22304",
    "data-name": "Path 22304",
    d: "M42.8,20.515c0,.23-.1.352-.257.363s-.268-.082-.3-.268a.285.285,0,0,0-.259-.279.258.258,0,0,0-.281.207c-.053.178.079.327.3.342a.834.834,0,0,1,.374,1.554c-.078.044-.135.077-.151.183a.272.272,0,0,1-.522.013.3.3,0,0,0-.172-.209.805.805,0,0,1-.4-.687.276.276,0,1,1,.551-.037.285.285,0,0,0,.267.289.253.253,0,0,0,.272-.2.275.275,0,0,0-.287-.355.832.832,0,0,1-.77-.591.821.821,0,0,1,.4-.972.2.2,0,0,0,.129-.161.275.275,0,0,1,.539,0c.013.094.061.121.127.157a.8.8,0,0,1,.436.645",
    transform: "translate(-37.256 -16.996)",
    fill: "#0072ce"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingBuyerInfo);
export default __webpack_public_path__ + "static/media/Pricing, Buyer Info.9f750e86d8b3f581d454a6723801f271.svg";
export { ForwardRef as ReactComponent };